const initialState = {
  hasTwitter: false
}

const twitterReducer = (state = initialState, action) => {
    switch (action.type) {
      case "ADD_TWITTER":
        return {
          ...state,
          twitter: action.twitter,
        };
      case "HAS_TWITTER":
        return {
          ...state,
          hasTwitter: true,
        };
  
      default:
        return state;
    }
}

export default twitterReducer;